import { gql } from "@apollo/client";


export const GET_ALL_RECEIPT_ATTACHMENTS = gql`
  query GetAllReceiptAttachments {
    getAllReceiptAttachments {
      attachment_id
      receipt_id
      attachment_type
      file_url
      created_at
    }
  }
`;

export const GET_RECEIPT_ATTACHMENT_BY_ID = gql`
  query GetReceiptAttachmentById($attachment_id: ID!) {
    getReceiptAttachmentById(attachment_id: $attachment_id) {
      attachment_id
      receipt_id
      attachment_type
      file_url
      created_at
    }
  }
`;

export const GET_ATTACHMENTS_BY_RECEIPT = gql`
  query GetAttachmentsByReceiptId($receipt_id: ID!) {
    getAttachmentsByReceiptId(receipt_id: $receipt_id) {
      attachment_id
      receipt_id
      attachment_type
      file_url
      created_at
    }
  }
`;


export const CREATE_RECEIPT_ATTACHMENT = gql`
  mutation CreateReceiptAttachment($input: createReceiptAttachmentInput!) {
    createReceiptAttachment(input: $input) {
      attachment_id
      receipt_id
      attachment_type
      file_url
      created_at
    }
  }
`;

export const UPDATE_RECEIPT_ATTACHMENT = gql`
  mutation UpdateReceiptAttachment($input: updateReceiptAttachmentInput!) {
    updateReceiptAttachment(input: $input) {
      attachment_id
      receipt_id
      attachment_type
      file_url
      created_at
    }
  }
`;

export const DELETE_RECEIPT_ATTACHMENT = gql`
  mutation DeleteReceiptAttachment($attachment_id: ID!) {
    deleteReceiptAttachment(attachment_id: $attachment_id)
  }
`;
